import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'

import Onboarding from 'modules/pagamentos/pages/Onboarding'
import TermosDeUsoOnboardingImpl from 'modules/pagamentos/domain/usecases/TermosOnboarding'
import AceitarTermosOnboardingImpl from 'modules/pagamentos/domain/usecases/AceitarTermosOnboarding'
import EnviarDocumentoOnboardingImpl from 'modules/pagamentos/domain/usecases/EnviarDocumentoOnboarding'
import CreateContaPJOnboardingImpl from 'modules/pagamentos/domain/usecases/CreateContaPJOnboarding'
import ConfirmarEnvioDocumentosOnboardingImpl from 'modules/pagamentos/domain/usecases/ConfirmarEnvioDocumentosOnboarding'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import ConsultZipCodeImpl from 'modules/user/domain/usecases/ConsultZipCodeImpl'
import ValidarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'
import EnviarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import GetPercentualTransferenciaMotoristaImpl from 'modules/pagamentos/domain/usecases/GetPercentualTransferenciaMotorista'
import UpdatePercentualTransferenciaMotoristaImpl from 'modules/pagamentos/domain/usecases/UpdatePercentualTransferenciaMotorista'

export const OnboardingFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const validarPinTmovPay = new ValidarPinTmovPayImpl(pagamentoRepository)
  const enviarPinTmovPay = new EnviarPinTmovPayImpl(pagamentoRepository)
  const termosAceiteOnboarding = new TermosDeUsoOnboardingImpl(
    pagamentoRepository,
  )
  const aceitarTermosDeUsoOnboarding = new AceitarTermosOnboardingImpl(
    pagamentoRepository,
  )
  const enviarDocumentoOnboarding = new EnviarDocumentoOnboardingImpl(
    pagamentoRepository,
  )
  const createContaPJOnboarding = new CreateContaPJOnboardingImpl(
    pagamentoRepository,
  )
  const confirmarEnvioDocumentosOnboarding =
    new ConfirmarEnvioDocumentosOnboardingImpl(pagamentoRepository)
  const userRepository = new UserRepository()
  const consultZipCode = new ConsultZipCodeImpl(userRepository)
  const getPercentualTransferenciaMotorista =
    new GetPercentualTransferenciaMotoristaImpl(pagamentoRepository)
  const updatePercentualTransferenciaMotorista =
    new UpdatePercentualTransferenciaMotoristaImpl(pagamentoRepository)

  return (
    <Onboarding
      termosAceiteOnboarding={termosAceiteOnboarding}
      aceitarTermosDeUsoOnboarding={aceitarTermosDeUsoOnboarding}
      enviarDocumentoOnboarding={enviarDocumentoOnboarding}
      createContaPJOnboarding={createContaPJOnboarding}
      confirmarEnvioDocumentosOnboarding={confirmarEnvioDocumentosOnboarding}
      enviarPinTmovPay={enviarPinTmovPay}
      validarPinTmovPay={validarPinTmovPay}
      consultZipCode={consultZipCode}
      updatePercentualTransferenciaMotorista={
        updatePercentualTransferenciaMotorista
      }
      getPercentualTransferenciaMotorista={getPercentualTransferenciaMotorista}
    />
  )
}

export default OnboardingFactory
